import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-b from-muted/30 to-white">
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-12 animate-in fade-in slide-in-from-bottom-4 duration-1000">
            <img
              src="https://customer-assets.emergentagent.com/job_f370c0b3-8057-480a-bb12-a2b7e5c6317d/artifacts/u1yypgyd_Logo%203D-v3.png"
              alt="Voltaris Industry & Renewables Logo"
              className="w-full max-w-md mx-auto h-auto"
            />
          </div>

          {/* Tagline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-200">
            {t('company.tagline')}
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed mb-12 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
            {t('company.description')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
            <Link
              to="/services"
              className="px-8 py-4 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 inline-flex items-center justify-center gap-2"
            >
              {t('hero.cta1')}
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 bg-white text-primary border-2 border-primary rounded-lg font-semibold hover:bg-primary hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 inline-flex items-center justify-center gap-2"
            >
              {t('hero.cta2')}
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>

          {/* Quick Links to other pages */}
          <div className="mt-16 pt-8 border-t">
            <p className="text-sm text-muted-foreground mb-4">{t('nav.explore') || 'Explora más sobre nosotros'}</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/about" className="text-primary hover:underline">{t('nav.about')}</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/quality-policy" className="text-primary hover:underline">{t('nav.quality')}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePage;
